import './QuoteSkeleton.scss';

const QuoteSkeleton = () => {

  return (
    <div className='home__quote__section__skeleton'>
      <div className='quote__content__skeleton'>
        <div className='quote__title__skeleton'></div>
        <div className='quote__subtitle__skeleton'></div>
        <div className='quote__subtitle__skeleton--primary'></div>
        <div className='quote__button__skeleton'></div>
      </div>
    </div>
  );
};

export default QuoteSkeleton;